import { uiActions, uiSelectors } from '~/store';
import { MAIN_SCREEN_MODALS } from '~/lib/constants';

function displayMandatoryProfitDistributionPopup(state) {
	if (!shouldDisplay(state)) {
		return;
	}

	return uiActions.changeActiveModal(MAIN_SCREEN_MODALS.MANDATORY_PROFIT_DISTRIBUTION_MODAL);
}

function shouldDisplay(state) {
	return uiSelectors.shouldShowMandatoryProfitDistributionModal(state);
}

export default displayMandatoryProfitDistributionPopup;
